




























import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import VueTimepicker from 'vue2-timepicker';
import ClockIcon from '@/components/icons/Clock.vue';
import ArrowDownIcon from '@/components/icons/Arrow.vue';
import DateUtils from '@/utils/DateUtils';
import { uses24HourClock } from '@/utils/clockFormat';

@Component({
  components: {
    Typography,
    VueTimepicker,
    ClockIcon,
    ArrowDownIcon
  }
})
export default class TimePicker extends Vue {
  @Prop() value!: string;

  displayTime = this.defaultDisplayTime();
  time = this.tranformValueToTime(this.value);

  // A method: the data initializers above call it before computed properties exist.
  is24Hour() {
    return uses24HourClock(this.$i18n.locale);
  }

  defaultDisplayTime() {
    if (this.value) {
      const [hour, minute] = this.value.split(':');
      if (hour === '00' && minute === '00') {
        return this.is24Hour() ? '00:00' : '12:00 am';
      }
    }
    return this.is24Hour() ? '--:--' : `--:-- am`;
  }

  tranformValueToTime(value?: string) {
    if (!value) return '';

    const [hour, minute] = value.split(':');

    if (this.is24Hour()) return `${hour}:${minute}`;

    const hourFormatted = DateUtils.hour24FormatTo12Format(hour);

    return `${hourFormatted}:${minute} ${Number(hour) >= 12 ? 'pm' : 'am'}`;
  }

  changeValue({ data }: any) {
    const is24Hour = this.is24Hour();
    const displayTime = `${is24Hour ? data.HH : data.hh}:${data.mm || '--'}`;
    const value = `${data.HH}:${data.mm || '--'}`;

    const formattedDisplayTime = displayTime
      ? displayTime.replace('mm', '--').replace('HH', '--')
      : displayTime;

    this.displayTime = is24Hour
      ? formattedDisplayTime
      : `${formattedDisplayTime} ${data.a || 'am'}`;
    this.time = displayTime;
    this.$emit('changeTime', `${value || '00:00'}:00`);
  }
}
